import { render } from "./bootstrapmodal.vue?vue&type=template&id=4b682b90"
import script from "./bootstrapmodal.vue?vue&type=script&lang=js"
export * from "./bootstrapmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__